export enum UserType {
  Internal = 'Internal',
  External = 'External'
}
